import { render, staticRenderFns } from "./GlossaryEditor.vue?vue&type=template&id=92f16fba&"
import script from "./GlossaryEditor.vue?vue&type=script&lang=js&"
export * from "./GlossaryEditor.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryEditor.vue?vue&type=style&index=0&id=92f16fba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports